import { useEffect, useState } from 'react'
const StatusProgressbar = ({ statusList }) => {
  const [statusBarWidth, setStatusBarWidth] = useState()
  useEffect(() => {
    const activeStepIndex =
      statusList.findIndex(step => step.isCurrentStatus) + 1
    const activeStepWidth = (activeStepIndex / statusList.length) * 100
    setStatusBarWidth(activeStepWidth)
  }, [statusList])
  return (
    <div className='flex flex-col justify-center status-bar-view'>
      {/* Horizontal Progress Bar */}
      <div className='relative mt-4'>
        {/* Gray background bar */}
        <div className='w-full h-4 bg-gray-300 rounded-full'>
          {/* Green progress bar */}
          <div
            className='h-full bg-green-500 rounded-full'
            style={{ width: `${statusBarWidth}%` }} // Adjust progress dynamically
          ></div>
        </div>
        <div className='flex justify-between relative progress bottom-4'>
          {statusList.map((step, index) => (
            <div key={index} className='text-center'>
              <div
                className={`indicator w-4 h-4 border rounded-full mx-auto relative z-10 ${
                  step.isCurrentStatus
                    ? 'bg-green-500 bg-white border-green-500'
                    : 'bg-white border-gray-400'
                }`}
              ></div>
              <span
                className={`mt-1 block text-sm ${
                  step.isCurrentStatus
                    ? 'text-green-500 font-bold'
                    : 'text-gray-500'
                }`}
              >
                {step.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default StatusProgressbar
